import {type ParsedQs, parse} from 'qs';
import {useLocation} from 'react-router';
import {logError} from 'logging';

type CallbackParamState = {
  redirect: string;
};

type CallbackParams = {
  code: string | null;
  state: CallbackParamState | null;
  error: string | null;
};
export const useCallbackParams = (): CallbackParams => {
  let {search, hash} = useLocation();

  search = search.substring(1); // Removes ?
  hash = hash.substring(1); // Removes #

  const params = {
    ...parse(search),
    ...parse(hash),
  };

  const {error, error_description} = params;

  if (error || error_description) {
    logError(
      `Error: ${error || '(empty)'}, description: ${
        error_description || '(empty)'
      }`,
    );
  }

  return {
    code: parsedQsToString(params.code),
    state: parseState(parsedQsToString(params.state)),
    error: parsedQsToString(params.error),
  };
};

const parsedQsToString = (
  value: undefined | string | ParsedQs | (string | ParsedQs)[],
): string | null => {
  if (Array.isArray(value)) {
    return value.join(',');
  }

  return value ? value.toString() : null;
};

/**
 * State comes as a string with two parts separated by a semicolon, if a redirect
 * was provided by Login
 */
const parseState = (value: string | null): CallbackParamState | null => {
  if (value) {
    const parts = value.split(';');
    if (parts.length > 1) {
      return {
        redirect: parts[1],
      };
    }
  }

  return null;
};
